<template>
  <div>
    <!-- 物流方式解析 -->
    <Modal v-model="analysisLogistics" @on-cancel="closeMatchModal" :mask-closable="false" title="物流解析" width="85%" @on-visible-change="visibleFn">
      <div class="info_title">
        <div class="line_box">
          <div class="line_item">
            <span class="title">发货仓库：</span>
            <span>{{ infolist.deliveryWarehouse }}</span>
          </div>
        </div>
        <div class="line_box">
          <div class="line_item">
            <span class="title">收件国家/地区：</span>
            <span>{{ infolist.receivingCountry }}</span>
          </div>
          <div class="line_item">
            <span class="title">订单平台：</span>
            <span>{{ infolist.platformId }}</span>
          </div>
        </div>
        <div class="line_box">
          <div class="line_item">
            <span class="title">预估重量(g)：</span>
            <span>{{ infolist.totalWeight }}</span>
          </div>
          <div class="line_item">
            <span class="title">预估尺寸(cm)：</span>
            <span>{{ infolist.estimatedSize }}</span>
          </div>
          <div class="line_item">
            <span class="title">预估体积(cm³)：</span>
            <span>
              {{((infolist.length || 0)*(infolist.width || 0)*(infolist.height || 0)).toFixed(2)}} cm³
            </span>
          </div>
          <div class="line_item">
            <span class="title">预估周长(cm)：</span>
            <span>
              {{(Number(infolist.length || '0') + 2*(Number(infolist.width || '0') + Number(infolist.height || '0'))).toFixed(2)}} cm
            </span>
          </div>
        </div>
        <div class="line_box mt15" v-if="isOldType">
          <div class="line_item">
            <Checkbox v-model="filterParams.appropriate" @on-change="changeAppropriate">只查看合适当前平台邮寄方式</Checkbox>
            <Tooltip placement="bottom" theme="light" max-width="250">
              <Icon class="ml10" size="20" type="md-help-circle" />
              <div slot="content">
                <span style="font-size: 12px;">物流设置中，该邮寄方式设置了当前平台的carrier信息，则视为匹配</span>
              </div>
            </Tooltip>
          </div>
        </div>
      </div>
      <div class="filter-content mt15">
        <Form ref="filterFormRef" :model="filterParams">
          <Form-item label="物流商" prop="merchantCarrierIdList" :label-width="60" v-show="isOldType">
            <dyt-select v-model="filterParams.merchantCarrierIdList" :max-tag-count="1" multiple placeholder="请选择物流商">
              <Option v-for="(item, index) in shippingDataList" :key="index" :value="item.value" :label="item.label" />
            </dyt-select>
          </Form-item>
          <Form-item label="邮寄方式" prop="merchantShippingMethod" :label-width="80">
            <dyt-input placeholder="请输入邮寄方式" v-model="filterParams.merchantShippingMethod" />
          </Form-item>
          <Form-item label="是否存在限制" prop="isLimit" :label-width="100" v-show="isOldType">
            <dyt-select v-model="filterParams.isLimit" placeholder="请选择">
              <Option :value="1" label="是" />
              <Option :value="0" label="否" />
            </dyt-select>
          </Form-item>
          <Form-item class="btn-item" label="" :label-width="0">
            <Button class="ml10" type="primary" icon="md-search" @click="GetlogisticsData('click')" :disabled="searchLoading">查询</Button>
          </Form-item>
        </Form>
      </div>
      <!--物流相关设置-->
      <h3 class="commodity_title">物流相关设置：</h3>
      <Form class="setAllMarkRead white-space-nowrap-form mb20">
        <Row>
          <Col :span="9" :offset="1" v-show="isOnlineShip === 0 && carrierAccounts.length > 0 && !isPms">
          <Form-item label="帐号：" :label-width="60">
            <dyt-select v-model="shippingAccountModel" :transfer="true">
              <Option
                v-for="(item, index) in carrierAccounts"
                v-if="item.carrierAccountId !== null"
                :key="index" :value="item.carrierAccountId"
                :label="item.account"
              />
            </dyt-select>
          </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="12" v-for="(item,index) in carrierBaseSetting" :key="index" v-show="item.paramType !== 'hide'">
          <Form-item :label="item.paramName" :label-width="100">
            <Radio-group v-model="shippingMethodModel[index].paramValue" v-if="item.paramType === 'radio'">
              <Radio :label="sItem.itemValue" v-for="(sItem,n) in item.dictionarys" :key="n">
                <span>{{ sItem.itemName }}</span>
              </Radio>
            </Radio-group>
            <Input v-if="item.paramType == 'input'" v-model="shippingMethodModel[index].paramValue"></Input>
            <Checkbox-group v-model="shippingMethodModel[index].paramValue" v-if="item.paramType == 'checkbox'">
              <Checkbox v-for="(sItem,n) in item.dictionarys" :key="n" :label="sItem.itemValue">
                <span>{{ sItem.itemName }}</span>
              </Checkbox>
            </Checkbox-group>
            <dyt-select v-if="item.paramType === 'select'" v-model="shippingMethodModel[index].paramValue">
              <Option v-for="(sItem,n) in item.dictionarys" :key="n" :value="sItem.itemValue" :label="sItem.itemName" />
            </dyt-select>
            <span v-if="['readOnly'].includes(item.paramType)">{{ item.paramValue }}</span>
          </Form-item>
          </Col>
        </Row>
      </Form>
      <div class="orderTable normalTop analysis-logistics-table" style="padding: 0;" v-if="analysisLogistics">
        <Table
          highlight-row
          border
          max-height="420"
          :columns="logisticsColumn"
          :data="logisticsData"
          :loading="searchLoading"
          @on-sort-change="tableDataSort"
        />
      </div>
      <div slot="footer" style="padding: 20px 0 10px 0; text-align: center">
        <Button :loading="pageLoading || searchLoading" @click="selectBtn" type="primary">选择</Button>
        <Button @click="closeMatchModal">关闭</Button>
      </div>
      <Spin fix v-if="pageLoading"></Spin>
    </Modal>
  </div>
</template>

<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';

export default {
  mixins: [Mixin],
  props: {
    orderDetailsData: Object,
    currentIndex: Number,
    allStorelist: Array,
    activePlatform: { type: String, default: '' },
    orderId: { type: String, default: '' }
  },
  data () {
    return {
      infolist: {},
      analysisLogistics: false,
      radioData: null,
      isPms: false,
      pageLoading: false,
      searchLoading: false,
      searchState: false,
      allCustomPlatform: [],
      allPlatformJson: {},
      shippingDataList: [],
      logisticsConfig: {},
      filterParams: {
        orderShippingId: null,
        onlyPlatform: '',
        merchantCarrierIdList: [],
        merchantShippingMethod: '',
        isLimit: 0,
        appropriate: false,
      },
      logisticsTableColJson: {
        operate: {
          title: '操作',
          width: 80,
          align: 'center',
          render: (h, params) => {
            let data = params.row;
            let talg = false;
            this.carrierBaseSetting = [];
            this.shippingMethodModel = [];
            this.carrierAccounts = [];
            this.radioData === data ? talg = true : talg = false;
            return h('Radio', {
              props: {
                size: 'small',
                value: talg
              },
              on: {
                'on-change': (value) => {
                  this.radioData = data;
                  this.isOnlineShip = data.isOnline;
                  this.isPms = this.$common.isEmpty(data.isPms) ? false : data.isPms;
                  if (data.carrierParamList != null && data.carrierParamList.length > 0) {
                    data.carrierParamList.map((n) => {
                      this.$nextTick(() => {
                        this.shippingMethodModel.push({
                          paramKey: n.paramKey,
                          paramValue: n.paramValue,
                          title: n.paramName
                        });
                      });
                    });
                  }
                  this.$nextTick(() => {
                    this.carrierAccounts = data.carrierAccounts;
                    this.carrierBaseSetting = data.carrierParamList;
                  });
                }
              }
            });
          }
        },
        carrierName: {
          title: '物流商',
          key: 'carrierName',
          width: 140,
          align: 'center'
        },
        carrierShippingMethodName: {
          title: '邮寄方式',
          key: 'carrierShippingMethodName',
          width: 140,
          align: 'center'
        },
        minEfficiency: {
          title: '参考时效(天)',
          key: 'minEfficiency',
          width: 110,
          sortable: 'custom',
          align: 'center',
          sortConfig: [
            { sortKey: 'minEfficiency' },
            { sortKey: 'maxEfficiency' }
          ],
          render: (h, { row }) => {
            let efficiency = row.minEfficiency + '-' + row.maxEfficiency;
            return h('div', efficiency);
          }
        },
        maxEfficiency: {
          title: '参考时效(天)',
          key: 'minEfficiency',
          width: 110,
          sortable: 'custom',
          align: 'center',
          sortConfig: [
            { sortKey: 'maxEfficiency' },
            { sortKey: 'minEfficiency' }
          ],
          render: (h, { row }) => {
            let efficiency = row.maxEfficiency + '-' + row.minEfficiency;
            return h('div', efficiency);
          }
        },
        otherFreight: {
          title: '物流费用',
          key: 'freight',
          sortConfig: [
            { sortKey: 'freight' },
            { sortKey: 'minEfficiency' },
            { sortKey: 'maxEfficiency' },
          ],
          width: 100,
          sortable: 'custom',
          sortType: 'asc',
          align: 'center',
          render: (h, { row }) => {
            if (this.$common.isEmpty(row.freight)) return h('div', {}, '');
            if (this.$common.isEmpty(Number(row.freight))) {
              return h('div', {}, [
                h('div', {}, row.freight),
                h('div', {}, row.currency || 'CNY'),
              ]);
            }
            return h('div', {}, [
              h('div', {}, Number(row.freight).toFixed(2)),
              h('div', {}, row.currency || 'CNY'),
            ]);
          }
        },
        guCuangFreight: {
          title: '物流费用',
          key: 'freight',
          sortConfig: [
            { sortKey: 'freight' },
            { sortKey: 'maxEfficiency' },
            { sortKey: 'minEfficiency' },
          ],
          width: 100,
          sortable: 'custom',
          sortType: 'asc',
          align: 'center',
          render: (h, { row }) => {
            if (this.$common.isEmpty(row.freight)) return h('div', {}, '');
            if (this.$common.isEmpty(Number(row.freight))) {
              return h('div', {}, [
                h('div', {}, row.freight),
                h('div', {}, row.currency || 'CNY'),
              ]);
            }
            return h('div', {}, [
              h('div', {}, Number(row.freight).toFixed(2)),
              h('div', {}, row.currency || 'CNY'),
            ]);
          }
        },
        incomeDetailBoList: {
          title: '费用明细',
          key: 'incomeDetailBoList',
          minWidth: 100,
          align: 'center',
          render: (h, { row }) => {
            if (this.$common.isEmpty(row.incomeDetailBoList)) return h('div', {}, '');
            const allItem = row.incomeDetailBoList.map((m, index) => {
              return h('div', {
                style: {
                  'display': 'inline-block'
                },
                class: 'mr10',
              }, [
                h('span', {}, `${m.name || ''}：`),
                h('span', {}, this.$common.isEmpty(m.amount) ? 0 : m.amount),
                h('span', {
                  class: 'ml5',
                }, row.currency || ''),
              ]);
            });
            return h('div', {
              style: {
                'display': 'inline-block',
                'margin': '0 auto',
                'text-align': 'left',
              }
            }, allItem);
          }
        },
        arriveable: {
          title: '配送范围',
          key: 'arriveable',
          minWidth: 90,
          align: 'center',
          render: (h, params) => {
            let typeName = '';
            let type = params.row.arriveableType;
            switch (type) {
              case 1:
                typeName = '全球可达运费相同';
                break;
              case 2:
                typeName = '全球可达运费不同';
                break;
              case '3':
                typeName = '非全球可达';
                break;
              default:
                typeName = '';
            }
            return h('div', {
              style: {
                color: params.row.arriveableMatch ? '#078307' : '#FF0802'
              }
            }, typeName);
          }
        },
        platformLimitMatch: {
          title: '是否平台限制',
          key: 'platformLimitMatch',
          minWidth: 70,
          align: 'center',
          renderHeader: (h, col) => {
            return h('div', {}, [
              h('div', {}, '是否平'),
              h('div', {}, '台限制')
            ])
          },
          render: (h, { row }) => {
            let isLimit = false;
            if (!this.$common.isEmpty(row.platformLimitMatch) && !row.platformLimitMatch) {
              isLimit = true;
            }
            return h('div', {
              style: {
                color: isLimit ? '#f20' : ''
              }
            }, isLimit ? '是' : '否');
          }
        },
        maxLength: {
          title: '最大尺寸限制(cm)',
          key: 'maxLength',
          minWidth: 80,
          align: 'center',
          renderHeader: (h, col) => {
            return h('div', {}, [
              h('div', {}, '最大尺寸'),
              h('div', {}, '限制(cm)')
            ])
          },
          render: (h, params) => {
            let size = this.$common.isEmpty(params.row.maxLength) ? '' : params.row.maxLength;
            if (!this.$common.isEmpty(params.row.maxWidth)) {
              size = `${size}${this.$common.isEmpty(size) ? '' : '*'}${params.row.maxWidth}`;
            }
            if (!this.$common.isEmpty(params.row.maxHeight)) {
              size = `${size}${this.$common.isEmpty(size) ? '' : '*'}${params.row.maxHeight}`;
            }
            return h('div', {
              style: {
                color: params.row.maxLengthMatch && params.row.maxWidthMatch && params.row.maxHeightMatch ? '#078307' : '#FF0802'
              }
            }, size);
          }
        },
        minLength: {
          title: '最小尺寸限制(cm)',
          key: 'minLength',
          minWidth: 80,
          align: 'center',
          renderHeader: (h, col) => {
            return h('div', {}, [
              h('div', {}, '最小尺寸'),
              h('div', {}, '限制(cm)')
            ])
          },
          render: (h, params) => {
            let size = this.$common.isEmpty(params.row.minLength) ? '' : params.row.minLength;
            if (!this.$common.isEmpty(params.row.minWidth)) {
              size = `${size}${this.$common.isEmpty(size) ? '' : '*'}${params.row.minWidth}`;
            }
            if (!this.$common.isEmpty(params.row.minHeight)) {
              size = `${size}${this.$common.isEmpty(size) ? '' : '*'}${params.row.minHeight}`;
            }
            return h('div', {
              style: {
                color: params.row.minLengthMatch && params.row.minWidthMatch && params.row.minHeightMatch ? '#078307' : '#FF0802'
              }
            }, size);
          }
        },
        minWeight: {
          title: '重量限制(g)',
          key: 'minWeight',
          minWidth: 80,
          align: 'center',
          renderHeader: (h, col) => {
            return h('div', {}, [
              h('div', {}, '重量'),
              h('div', {}, '限制(g)')
            ])
          },
          render: (h, params) => {
            let volume = this.$common.isEmpty(params.row.minWeight) ? '' : params.row.minWeight;
            if (!this.$common.isEmpty(params.row.maxWeight)) {
              volume = `${volume}${this.$common.isEmpty(volume) ? '' : '-'}${params.row.maxWeight}`;
            }
            return h('div', {
              style: {
                color: params.row.weightMatch ? '#078307' : '#FF0802'
              }
            }, volume);
          }
        },
        volume: {
          title: '体积限制(cm)',
          key: 'volume',
          minWidth: 80,
          align: 'center',
          renderHeader: (h, col) => {
            return h('div', {}, [
              h('div', {}, '体积'),
              h('div', {}, '限制(cm)')
            ])
          },
          render: (h, params) => {
            let volume = this.$common.isEmpty(params.row.minVolume) ? '' : params.row.minVolume;
            if (!this.$common.isEmpty(params.row.maxVolume)) {
              volume = `${volume}${this.$common.isEmpty(volume) ? '' : '-'}${params.row.maxVolume}`;
            }
            return h('div', {
              style: {
                color: params.row.volumeMatch ? '#078307' : '#FF0802'
              }
            }, volume);
          }
        },
        perimeter: {
          title: '周长限制(cm)',
          key: 'perimeter',
          minWidth: 80,
          align: 'center',
          renderHeader: (h, col) => {
            return h('div', {}, [
              h('div', {}, '周长'),
              h('div', {}, '限制(cm)')
            ])
          },
          render: (h, params) => {
            return h('div', {
              style: {
                color: params.row.perimeterMatch ? '#078307' : '#FF0802'
              }
            }, params.row.maxPerimeter);
          }
        },
        dimensions: {
          title: '最长边限制(cm)',
          key: 'dimensions',
          minWidth: 80,
          align: 'center',
          renderHeader: (h, col) => {
            return h('div', {}, [
              h('div', {}, '最长边'),
              h('div', {}, '限制(cm)')
            ])
          },
          render: (h, params) => {
            return h('div', {
              style: {
                color: params.row.dimensionsLengthMatch ? '#078307' : '#FF0802'
              }
            }, params.row.maxDimensionsLength);
          }
        },
        maxThreeSidesAnd: {
          title: '三边和限制(cm)',
          minWidth: 80,
          key: 'maxThreeSidesAnd',
          align: 'center',
          renderHeader: (h, col) => {
            return h('div', {}, [
              h('div', {}, '三边和'),
              h('div', {}, '限制(cm)')
            ])
          },
          render: (h, params) => {
            return h('div', {
              style: {
                color: params.row.maxThreeSidesAndMatch ? '#078307' : '#FF0802'
              }
            }, params.row.maxThreeSidesAnd);
          }
        },
        maxLongestTwoSidesAnd: {
          title: '最长两边和限制(cm)',
          minWidth: 80,
          key: 'maxLongestTwoSidesAnd',
          align: 'center',
          renderHeader: (h, col) => {
            return h('div', {}, [
              h('div', {}, '最长两边和'),
              h('div', {}, '限制(cm)')
            ])
          },
          render: (h, params) => {
            return h('div', {
              style: {
                color: params.row.maxLongestTwoSidesAndMatch ? '#078307' : '#FF0802'
              }
            }, params.row.maxLongestTwoSidesAnd);
          }
        },
        acceptTypeMatch: {
          title: '接受类型限制',
          minWidth: 80,
          key: 'acceptTypeMatch',
          align: 'center',
          renderHeader: (h, col) => {
            return h('div', {}, [
              h('div', {}, '接受类'),
              h('div', {}, '型限制')
            ])
          },
          render: (h, params) => {
            let typeName = [];
            let typeArr = {
              '01': '普货',
              '02': '纯电池',
              '03': '配套电',
              '04': '液体',
              '05': '药品',
              '06': '粉末',
              '07': '危险品',
              '08': '内置电池'
            };
            if (params.row.acceptTypes.length > 0) {
              params.row.acceptTypes.map((item) => {
                typeName.push(typeArr[item]);
              });
            }
            return h('div', {
              style: {
                color: params.row.acceptTypeMatch ? '#078307' : '#FF0802'
              }
            }, typeName.length > 0 ? typeName.join('、') : '');
          }
        }
      },
      logisticsColumn: [],
      logisticsData: [],
      oldTableData: [],
      isOnlineShip: 0,
      carrierBaseSetting: [],
      shippingMethodModel: [],
      shippingAccountModel: null,
      carrierAccounts: [],
    };
  },
  computed: {
    warehouseInfo () {
      if (this.$common.isEmpty(this.currentIndex)) return {};
      if (this.$common.isEmpty(this.orderDetailsData) || this.$common.isEmpty(this.orderDetailsData.orderShippingInfoList)) return {};
      return this.orderDetailsData.orderShippingInfoList[this.currentIndex] || {};
    },
    // 是否为自定义平台
    isCustomPlatform () {
      const info = this.allCustomPlatform.find(item => item.platformId == this.activePlatform);
      return !this.$common.isEmpty(info);
    },
    // 订单信息
    orderInfo () {
      if (this.$common.isEmpty(this.orderDetailsData) || this.$common.isEmpty(this.orderDetailsData.orderInfo)) return {};
      return this.orderDetailsData.orderInfo;
    },
    orderType () {
      if (this.$common.isEmpty(this.orderInfo) || this.$common.isEmpty(this.orderInfo.orderType)) return '';
      return this.orderInfo.orderType;
    },
    isOldType () {
      if (!this.$common.isEmpty(this.orderType)) {
        if (['TIKTOK'].includes(this.orderType)) return true;
      }
      if (!this.$common.isEmpty(this.logisticsConfig) && !this.$common.isEmpty(this.logisticsConfig.type)) {
        return ![0].includes(Number(this.logisticsConfig.type));
      }
      return true;
    }
  },
  watch: {},
  methods: {
    // 关闭弹窗时，重置数据
    closeMatchModal () {
      this.filterParams.orderShippingId = null;
      this.filterParams.onlyPlatform = '0';
      this.filterParams.appropriate = true;
      this.$refs.filterFormRef && this.$refs.filterFormRef.resetFields();
      this.searchLoading = false;
      this.pageLoading = false;
      this.logisticsColumn = [];
      this.searchState = false;
      this.oldTableData = [];
      this.logisticsConfig = {};
      this.$nextTick(() => {
        this.$emit('changeLogistics', false);
      })
    },

    // 处理详情数据
    handleInfo () {
      return new Promise((resolve) => {
        let data = this.warehouseInfo;
        let platformId = this.orderDetailsData.orderInfo.platformId;
        if (data && Object.keys(data).length > 0) {
          let countryData = JSON.parse(localStorage.getItem('area'));
          let receivingCountry = '';
          let deliveryWarehouse = '';
          // 收件国家/地区
          if (countryData.length > 0) {
            countryData.map((item) => {
              if (item.twoCode === data.buyerCountryCode) {
                receivingCountry = item.cnName;
              }
            });
          }
          // 发货仓库
          if (this.allStorelist.length > 0) {
            this.allStorelist.map((item) => {
              if (item.warehouseId === data.warehouseId) {
                deliveryWarehouse = item.warehouseName;
              }
            });
          }
          let forecastSize = this.$common.isEmpty(data.length) ? '' : data.length;
          if (!this.$common.isEmpty(data.width)) {
            forecastSize = `${forecastSize}${this.$common.isEmpty(forecastSize) ? '' : '*'}${data.width}`;
          }
          if (!this.$common.isEmpty(data.height)) {
            forecastSize = `${forecastSize}${this.$common.isEmpty(forecastSize) ? '' : '*'}${data.height}`;
          }
          this.infolist = {
            ...data,
            deliveryWarehouse: deliveryWarehouse,
            receivingCountry: receivingCountry,
            platformId: platformId,
            totalWeight: data.totalWeight,
            estimatedSize: forecastSize
          };
          this.filterParams.orderShippingId = data.orderShippingId;
        }
        resolve({ state: 'finally', data: [] });
      })
    },
    // 获取所有平台信息 type = 1 是通用渠道, type = 2 是自定义渠道 status 为 1 是启用， 为 0 是停用
    getAllplatformInfo (status) {
      return new Promise((resolve) => {
        if (this.$common.isEmpty(status)) return resolve({ state: 'finally' });
        this.axios.get(`${api.get_queryByStatus}?status=${status}`, { hiddenError: true }).then(res => {
          if (!res || !res.data || res.data.code != 0) return resolve({ state: 'finally' });
          let newData = [];
          (res.data.datas || []).forEach(item => {
            this.$set(this.allPlatformJson, item.platformId, item);
            if (item.type == 2) {
              newData.push(item);
            }
          });
          this.allCustomPlatform = [...this.allCustomPlatform, ...newData];
          resolve({ state: 'finally' });
        }).catch(() => {
          resolve({ state: 'finally' });
        })
      });
    },
    getFilterParams () {
      let params = this.$common.copy(this.filterParams);
      params.onlyPlatform = this.filterParams.appropriate ? '1' : '0';
      params.merchantShippingMethod = (params.merchantShippingMethod || '').trim();
      delete params.appropriate;
      if (!this.isOldType) {
        params.merchantShippingMethod = '';
        delete params.merchantCarrierIdList;
        delete params.isLimit;
        delete params.onlyPlatform;
      }
      return params;
    },
    // 获取可用的物流方式
    GetlogisticsData (str = 'search') {
      return new Promise((resolve) => {
        if (this.searchLoading) return resolve({ state: 'loading' });
        this.searchLoading = true;
        this.logisticsData = [];
        const isClickQuery = ['click'].includes(str) && !this.isOldType;
        const sortObj = [
          { sortKey: 'freight', sortType: 'asc' },
          { sortKey: !this.isOldType ? 'maxEfficiency' : 'minEfficiency', sortType: 'asc' },
          { sortKey: !this.isOldType ? 'minEfficiency' : 'maxEfficiency', sortType: 'asc' },
        ];
        if (this.searchState && isClickQuery) {
          let filterData = (this.oldTableData || []);
          const searchStr = (this.filterParams.merchantShippingMethod || '').trim();
          if (!this.$common.isEmpty(searchStr)) {
            filterData = filterData.filter(row => {
              return (row.carrierShippingMethodName || '').includes(searchStr);
            });
          }
          this.$nextTick(() => {
            this.logisticsData = this.$common.listPrioritySort(filterData, sortObj);
            this.searchLoading = false;
            resolve({ state: 'finally' });
          });
          return;
        }
        let query = this.getFilterParams();
        this.searchState = false;
        this.axios.post(api.get_analysisLogistics, query).then((response) => {
          if (response && response.data && response.data.code === 0) {
            this.searchState = true;
            this.oldTableData = this.$common.copy(response.data.datas || []);
            if (isClickQuery) {
              this.GetlogisticsData('click');
            } else {
              this.logisticsData = this.$common.listPrioritySort(this.oldTableData, sortObj);
            }
          }
          this.searchLoading = false;
          resolve({ state: 'finally' });
        }).catch(() => {
          this.searchLoading = false;
          resolve({ state: 'error' });
        });
      })
    },
    // 数据排序(支持多个优先级排序)
    tableDataSort ({ column, key, order }) {
      if (this.$common.isEmpty(column.sortConfig)) return;
      if (!['asc', 'desc'].includes(order)) {
        this.logisticsData = this.$common.copy(this.oldTableData);
        return;
      }
      const newSort = column.sortConfig.map(m => {
        return { ...m, sortType: order }
      });
      this.logisticsData = this.$common.listPrioritySort(this.oldTableData, newSort);
    },
    // 获取物流商下拉
    getShippingList () {
      return new Promise((resolve) => {
        let queryPar = {
          isFilter: true,
          time: (new Date().getTime()).toString(32)
        };
        if (!this.$common.isEmpty(this.warehouseInfo.warehouseId)) {
          queryPar.warehouseId = this.warehouseInfo.warehouseId;
        }
        if (!this.$common.isEmpty(this.warehouseInfo.warehouseType)) {
          queryPar.warehouseType = this.warehouseInfo.warehouseType;
        }
        this.shippingDataList = [];
        this.axios.get(`${api.erpServiceCommon}${api.get_enableCarriersApi}`, {
          params: queryPar,
          hiddenError: true
        }).then(res => {
          if (!res || !res.data || res.data.code != 0) return resolve([]);
          this.shippingDataList = (res.data.datas || []).map(item => {
            return { ...item, value: item.carrierId, label: item.carrierName }
          });
          resolve(this.shippingDataList);
        }).catch(() => {
          return resolve([]);
        })
      })
    },
    // 显示弹窗时
    visibleFn (value) {
      this.$nextTick(() => {
        if (!value) {
          this.filterParams.appropriate = false;
          this.radioData = null;
          return;
        }
        this.pageLoading = true;
        this.allCustomPlatform = [];
        this.allPlatformJson = {};
        this.initPageData().then((res) => {
          this.pageLoading = false;
          this.filterParams.appropriate = !this.isCustomPlatform;
          this.$nextTick(() => {
            this.GetlogisticsData();
          })
        }).catch(() => {
          this.pageLoading = false;
        });
      });
    },
    // 获取初始化数据
    initPageData () {
      return new Promise((resolve) => {
        // 前置加载的数据
        let beforeAwait = [
          this.handleInfo
        ];
        // 等待加载的数据
        let awaitRes = [
          this.getShippingList,
          () => {
            // 停用的平台
            return this.getAllplatformInfo('0');
          },
          () => {
            // 启用的平台
            return this.getAllplatformInfo('1');
          },
          () => {
            // 获取对应仓库智能物流规则查询
            return this.getLogisticsRuleType(this.warehouseInfo.warehouseId);
          }
        ];
        // 后置加载的数据
        let afterAwait = [
          // 处理表格列
          this.handleTableCol
        ];
        this.$common.promiseAll(beforeAwait).finally(() => {
          this.$common.promiseAll(awaitRes).then((arrRes) => {
            this.$common.promiseAll(afterAwait).finally(() => {
              resolve({ state: 'finally', data: arrRes });
            });
          }).catch((err) => {
            console.error(err);
            resolve({ state: 'finally', data: [] });
          })
        })
      })
    },
    // 处理表格列
    handleTableCol () {
      return new Promise((resolve) => {
        let newColList = [];
        if (!this.isOldType) {
          ['operate', 'carrierName', 'carrierShippingMethodName', 'maxEfficiency', 'guCuangFreight', 'incomeDetailBoList'].forEach(key => {
            if (this.logisticsTableColJson[key]) {
              newColList.push(this.logisticsTableColJson[key])
            }
          });
        } else {
          [
            'operate', 'carrierName', 'carrierShippingMethodName', 'minEfficiency', 'otherFreight', 'arriveable', 'platformLimitMatch', 'maxLength',
            'minLength', 'minWeight', 'volume', 'perimeter', 'dimensions', 'maxThreeSidesAnd', 'maxLongestTwoSidesAnd', 'acceptTypeMatch'
          ].forEach(key => {
            if (this.logisticsTableColJson[key]) {
              newColList.push(this.logisticsTableColJson[key])
            }
          });
        }
        this.logisticsColumn = newColList;
        resolve({ state: 'finally' });
      });
    },
    // 选取适合平台的邮寄方式
    changeAppropriate () {
      this.GetlogisticsData();
    },
    // 智能物流规则查询
    getLogisticsRuleType (id) {
      return new Promise((resolve) => {
        if (this.$common.isEmpty(id)) return resolve({ state: 'finally' });
        this.axios.get(api.logisticsRuleTypeGet, {
          params: {
            warehouseId: id
          }
        }).then(res => {
          if (res && res.data && res.data.code == 0 && !this.$common.isEmpty(res.data.datas)) {
            this.logisticsConfig = res.data.datas || {};
          }
          resolve({ state: 'finally' });
        }).catch(() => {
          resolve({ state: 'finally' });
        })
      })
    },
    // 重置数据
    popperHide () {
      this.carrierBaseSetting = [];
      this.shippingMethodModel = [];
      this.shippingAccountModel = null;
      this.carrierAccounts = [];
    },

    // 选择物流
    selectBtn () {
      let v = this;
      if (v.radioData === null) {
        v.$Message.error('请选择实际发货物流方式');
        return false;
      }
      if (this.$common.isEmpty(this.shippingAccountModel) && this.isOnlineShip === 0 && !this.isPms) {
        v.$Message.error('帐号不能为空');
        return false;
      }
      v.pageLoading = true;
      let obj = {
        orderShippingId: this.filterParams.orderShippingId,
        merchantCarrierId: v.radioData.carrierId,
        merchantShippingMethodId: v.radioData.shippingMethodId,
        packageCarrierParam: v.shippingMethodModel,
        carrierAccountId: v.shippingAccountModel,
        platformId: this.infolist.platformId,
        orderId: this.orderId
      };
      if (v.isOnlineShip === 1) {
        delete obj.carrierAccountId;
      }
      v.axios.put(api.update_singleShippingMethod, JSON.stringify(obj)).then(response => {
        if (response.data.code === 0) {
          v.$Message.success('操作成功');
          v.$emit('changeLogistics', false);
          v.popperHide();
          v.$emit('updateDetailsData', true);
        } else {
          v.popperHide();
          v.$Message.error('操作失败，请重新尝试');
        }
        v.$nextTick(function () {
          v.pageLoading = false;
        });
      }).catch(() => {
        v.$Message.error('操作失败，请重新尝试');
        v.$nextTick(function () {
          v.pageLoading = false;
        });
        v.popperHide();
      });
    }
  }
};
</script>
<style lang="less" scoped>
.analysis-logistics-table{
  :deep(.ivu-table-wrapper){
    .ivu-table-sort {
      width: 20px;
      height: 20px;
    }
    .ivu-table-sort i {
        height: 11px;
        line-height: 11px;
        font-size: 22px;
    }
  }
}
.info_title {
  border-bottom: 1px dashed #797979;

  .line_box {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    .line_item{
      margin-right: 50px;
    }
    .title {
      font-weight: bold;
      color: #333;
    }

    label {
      font-size: 14px;
    }
  }
}

.commodity_title {
  color: #333;
  font-size: 14px;
  font-weight: bold;
  margin: 0 0 5px 0;
}
.filter-content{
  position: relative;
  :deep(.ivu-form) {
    .ivu-form-item {
      display: inline-block;
      .ivu-form-item-label{
        padding-right: 5px;
      }
      .ivu-form-item-content{
        width: 200px;
      }
      &.btn-item{
        .ivu-form-item-content{
          width: auto;
        }
      }
    }
  }
}
</style>
